import C from "../constantes"
import Sales from '../../../services/sales'
import { cents } from '../../../filters/number'
import validaRecarga from '../../../validators/recarga-minima'
import isMultiple from '../../../validators/is-multiple'
import axios from 'axios';
import {EventBus} from '../../../event-bus';
import param from "../../../services/param";
import Contract from "../../../services/contracts";

export default {
  props: ['contract', 'planId'],
  data() {
    return {
      loading: undefined,
      taxRecharge:undefined,
      rechargeValue: 0,
      recharge: 1,

      qtdFix: 4,
      rechargesData: [],
      value: undefined,
      tax: '-',
      source: undefined,

      changeFlagEmail: "0",
      selectedValue: undefined,
      recVp: "",
      couponValue: '',
      couponError: ''
    }
  },

  created() {
    this.source = axios.CancelToken.source();
    if(this.contract.rechargeValue){
        this.value = this.rechargeValue = this.contract.rechargeValue;
        if(this.value > this.minValue){
          this.value = -1;
          this.calculateRecharge();
        }
    }
    this.contract.plan.planId = this.$route.query.planId;
    this.mostrarAlerta(this.contract.plan.planId);
  },

  watch: {
    changeFlagEmail(newValue) {
      this.contract.changeFlagEmail = newValue;
    },

    value(){
      this.contract.taxRecharge = this.tax
    }
  },


  mounted() {

    this.value = "";
    this.rechargesData = this.getFixesRecharges(this.planId, this.minValue, false);

    if(!this.value){
      this.contract.rechargeValue = this.value = this.rechargesData[0].value;
      this.contract.taxRecharge = this.tax;

    }

    if(this.value > -1 && this.value <= this.minValue){

      let a = this.rechargesData.find((o) => {
        if(!o) return false;
        return o.value == this.contract.rechargeValue
      });

      this.changeRecharge(a);
    }

    this.contract.lcFlag = false;

    var chave;

    if (this.contract.plan.planId == 21){
      this.chave = "LIMITE_CREDITO_PF";
    }else{
      if (this.contract.plan.planId == 31){
        this.chave = "LIMITE_CREDITO_PJ";
      }
    }

    //recupera o valor base
    param.getGeneralParameter({
      key: this.chave
    }).then((res) => {
      this.contract.limitCredit = res.value.replace(/[^0-9]/g, '');
    });



  },

  computed: {
    sameTax() {
      return this.newAdhesionTax == this.newVehicleTax
    },
    planId() {
      return this.$route.query.planId
    },
    CO(){

      return C;
    },
    isCaminhoParana(){
      return !!this.$parent.lead;
    },
    valueFormatted: function () {
      this.$nextTick(()=>{
        //para o cursor continuar no final do input
        $('#valueTotal').val($('#valueTotal').val());
      });
      return cents(this.rechargeValue).replace('R$', '');

    },
    minValue(){
      return this.getMinOpenValue(this.planId);
    },
    plan(){
      return this.$store.getters.getPlanById(this.planId);
    },
    newAdhesionTax(){
      return this.$store.getters.getNewAdhesionTax(this.planId);
    },
    newVehicleTax(){
      return this.$store.getters.getNewVehicleTax(this.planId);
    },
    guaranteeTax(){
      return this.$store.getters.getGuaranteeTax(this.planId);
    },
    monthlyTax(){
      return this.$store.getters.getMonthlyTax(this.planId);
    },
    bankAccountOptions(){
      return this.$store.getters.getBankAccountOptions(this.planId);
    },
    creditCardOptions(){
      return this.$store.getters.getCreditCardOptions(this.planId);
    },
    bankBillOption(){
      return this.$store.getters.getBankBillOption(this.planId);
    },
    qtdGratis(){
      return Math.floor( (this.value == -1 ? this.rechargeValue : this.value) / 50000);
    },
    promoId() {
      return this.$route.query.promoId;
    },
    coupon: {
      get() {
        return this.couponValue;
      },
      set(value) {
        this.couponError = '';
        this.couponValue = value ? value.replace(/[^a-zA-Z0-9]/g, '') : '';
      }
    },

  },

  methods: {
    calculate(value) {
      if (value < 1) return;
      let resp = [];
      let promise = Sales.calculateRechargeRate({
        value: value,
        planId: this.planId,
        contractId: 0,
      }).then((r) => {
        this.tax                    = r.tax;
        this.contract.rechargeValue = r.value;
      });
      this.$store.dispatch("loading", promise);
      return resp[0];

    },

    changeRecharge(item) {

      this.$emit('valorSelecionado', item);
      if(!item) return;
      this.calculate(item.value)

      if(item.value == -1){
        this.rechargeValue = 0;
      }
      EventBus.$emit('cleanErrors');
    },
    calculateRecharge: function () {
      if (
        !validaRecarga.validate(this.rechargeValue, [this.minValue]) ||
        !isMultiple.validate(this.rechargeValue, 5000)
      ) {
        this.tax = "-";
        return false;
      }

      this.source.cancel('cancelada');
      this.source = axios.CancelToken.source();
      this.waiting = true;
      this.loading = Sales.calculateRechargeRate({ cancelToken: this.source.token, value: this.rechargeValue, planId:  this.planId, contractId: 0})
        .then(resp => {
          this.tax = resp.taxTotal;
          this.contract.rechargeValue = resp.valueTotal;
          this.waiting = false;
          EventBus.$emit('cleanErrors');
        }).catch(err => {
          this.waiting = false;
          this.tax = '-';
        });
    },
    setTotal: function (newValue) {
      this.rechargeValue = newValue.replace(/[^0-9]/g, '');
      this.calculateRecharge();
    },

    validateAll(){
      this.contract.tax = this.tax;
      let vm = this;
      return this.$validator.validateAll().then(() => {
        // Valida cupom se estiver preenchido
        const coupon = vm.getCoupon();
        if (coupon) {
          return Sales.validateCoupon(coupon).then(res => {
            if (!res.valid) {
              vm.couponError = 'Cupom inválido';
              return Promise.reject('Cupom inválido');
            }
          }).catch(err => {
            vm.couponError = 'Cupom inválido';
            return Promise.reject('Cupom inválido');
          });
        }
      });
    },
    getCoupon() {
      return this.couponValue || null;
    },

    limiteFormatado() {

      return cents(this.contract.limitCredit);
    },

    mostrarAlerta(newVal) {
      
            try {
              Contract.getDetailPlanVp(newVal).then(resp =>{
                console.log(resp, "Detalhe do plano 2");
                this.recVp = resp.plan.recVp;
                console.log(this.recVp, "recVp");
              })
            } catch (error) {
              console.error('Erro na requisição: ', error);
              alert('Erro na requisição: ' + error.message);
            }
    }
}
}



// WEBPACK FOOTER //
// ./src/pages/common/adhesion/choose-recharge.js